import { captureError, Severity } from '@chegg/observability';
import { getCvidCookie } from '@chegg/utils';
import { AUTHORIZE_ERROR_MESSAGE, CW_TEAM_NAME } from '../constants/Strings';
export var captureAuthorizeErrors = function captureAuthorizeErrors(_ref) {
  var errorMessage = _ref.errorMessage,
    cvid = _ref.cvid,
    location = _ref.location;
  captureError({
    error: AUTHORIZE_ERROR_MESSAGE,
    location: location,
    severity: Severity.ERROR
  }, {
    teamName: CW_TEAM_NAME,
    message: errorMessage,
    cvid: cvid || getCvidCookie() || ''
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/captureAuthorizeErrors.js
// module id = 4118
// module chunks = 11